export default {
    BASE_URL: "https://api.merrillotc.com",
    BASE_WSS: "wss://ws.merrillotc.com",
    BASE_IO: "wss://ws.merrillotc.com",

    default_lang: 'en',
}